module.exports = __webpack_public_path__ + "static/media/wrong.cb6ae2a6.svg";